import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
// Types
import { APIResponseProps } from 'types/global';
// Utils
import { getUser } from 'services/productionV1/users';
// Context
import { useAuthState } from 'context/AuthContext';
// Assets
import Icon from 'assets/Icon';
// Elements
import { Loading } from 'elements/Loading';
// Styles
import styles from './style/drawerEvent.module.css';

interface DrawerEventProps {
  event: {
    activityType?: string,
    batchNo?: string,
    eventId: number,
    eventCreated?: string,
    eventType?: string, 
    lineNo?: number,
    username?: string,
  },
  handler: Function,
}

function DrawerEvent({ event, handler }:DrawerEventProps) {
  const {
    activityType,
    batchNo,
    eventCreated,
    eventType, 
    lineNo,
    username,
  } = event;
  // Auth State
  const { employee, user } = useAuthState();
  // State
  const [avatar, setAvatar] = useState('');
  const [avatarLoading, setAvatarLoading] = useState(true);
  const [fullName, setFullName] = useState('');

  // Functions
  const setUser = useCallback(async () => {
    if (username !== employee.userId) {
      if (username === 'AutomatedLineSystem') {
        setFullName('Automated System');
      } else {
        const { response }:APIResponseProps = await getUser(username);
        if (response) {
          setFullName(`${response.firstName} ${response.lastName}`);
        }
      }
    } else {
      setAvatar(user.avatar ? user.avatar : '');
      setFullName(`${employee.firstName} ${employee.lastName}`);
    }
    setAvatarLoading(false);
  }, [employee.firstName, employee.lastName, employee.userId, user.avatar, username]);

  useEffect(() => {
    setUser();
  }, [employee, user, username, setAvatar, setAvatarLoading, setFullName, setUser]);

  return (
    <div
      className={styles.container}
      onClick={() => handler()}
      onKeyDown={() => handler()}
      role="button"
      tabIndex={0}
    >
      { avatarLoading ? (
        <Loading size={32} fill="blueberry" />
      ) : (
        <>
          { avatar ? (
            <img src={avatar} alt={fullName} />
          ) : (
            <div className={styles.avatar}>
              { fullName.split(' ').map(n => n[0]).join('') }
            </div>
          )}
        </>
      )}
      <ul>
        <li className="subtitle1">{eventType} {activityType}</li>
        <li className={`body2 ${styles.details}`}>{`Batch: ${batchNo} | ${moment(eventCreated).format('DD-MMM-YYYY')} | ${lineNo}`}</li>
      </ul>
      <Icon icon="ChevronRight" fill="warm-grey-200" size={24} />
    </div>
  );
}

export default DrawerEvent;
